import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";
import { MembersOnlySheet } from "@/components/common/MembersOnlySheet";

// Shared translate control button. Pairs with useContentTranslation.
// Translation is a member benefit: a non-subscriber (guest or logged-in without a
// sub) still SEES the control (the visible control is the pitch) but tapping it
// opens the shared members-only upsell sheet instead of translating. Content
// stays readable in its original language; only the translation is gated.
export const TranslateToggle = ({ translating, slow = false, hasTranslation, showOriginal, onToggle, testid = "translate-toggle", className = "", style, size = 12 }) => {
  const { t } = useTranslation();
  const _pa = usePlatformAuth() || {};
  const isSubscriber = !!_pa.isSubscriber;
  const [showUpsell, setShowUpsell] = useState(false);
  const gated = !isSubscriber;
  const label = translating
    ? (slow ? t("common.translatingSlow") : t("common.translating"))
    : (!hasTranslation ? t("common.translate") : (showOriginal ? t("common.seeTranslation") : t("common.seeOriginal")));
  const handle = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (gated) { setShowUpsell(true); return; }
    onToggle(e);
  };
  return (
    <>
      <button
        type="button"
        data-testid={testid}
        onClick={handle}
        disabled={translating}
        style={style}
        className={`flex items-center gap-1 text-xs font-medium disabled:opacity-60 ${className}`}
      >
        <Globe size={size} className={translating ? "animate-spin" : ""} /> {label}
      </button>
      {gated && <MembersOnlySheet open={showUpsell} onClose={() => setShowUpsell(false)} />}
    </>
  );
};

export default TranslateToggle;
